import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import {Col} from 'reactstrap';
import he from 'date-fns/locale/he';
import {saveSelectedStartDate, saveSelectedEndDate} from '../cellcomAbroadBlockSlice';
import {lobbyTabsEnum} from '../cellcomAbroadVariables';
import {formatDatesToDifferentFormats, getSelectedDaysCount} from '../cellcomAbroadUtilities';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import {gaStartDateIsSelected, gaEndDateIsSelected} from './../gaReports';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
const DatePickerComponent = (props) => {
  const [startDate, setStartDate] = useState(() => {
    const start = props.data.dates.datePickerStartJSFormat;
    return start ? new Date(start) : null;
  });
  const [endDate, setEndDate] = useState(() => {
    const end = props.data.dates.datePickerEndJSFormat;
    return end ? new Date(end) : null;
  });


  useEffect(() => {  
    var dates = props.data.dates;  
    const start = dates.datePickerStartJSFormat;
    const end = dates.datePickerEndJSFormat;
    if(start && end && dates.isQueryParamStartDate && dates.isQueryParamEndDate){
      setStartDate(start ? new Date(start) : null);
      setEndDate(end ? new Date(end) : null);
    } 
  }, [props.data.dates]);

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (dates[1]) {
      formatAndSave(dates);
    } else if (dates[0]) {
      formatAndSaveStart(dates);
    }
  };

  const formatAndSaveStart = (dates) => {
    let formattedStartDate;

    dates.map((date, index) => {
      let formattedDate = formatDatesToDifferentFormats(date);

      if (index == 0) {
        gaStartDateIsSelected(
          props.data.activeLobbyTab,
          props.data.startedFromPackage,
          props.data.otpData.validatedCostumerData?.isSeparatedSale,
          props.data.epiStyleInitializationData.businessIndividualLobby
        );
        formattedStartDate = formattedDate.formattedISOS;
        props.saveSelectedStartDate({selectedStartDate: formattedDate.formattedUI, datePickerStartJSFormat: formattedStartDate});
      }
    });
  };

  const formatAndSave = (dates) => {
    let formattedStartDate;
    dates.map((date, index) => {
      let formattedDate = formatDatesToDifferentFormats(date);

      if (index == 0) {
        formattedStartDate = formattedDate.formattedISOS;
        props.saveSelectedStartDate({selectedStartDate: formattedDate.formattedUI, datePickerStartJSFormat: formattedStartDate});
      } else {
        let daysCount = getSelectedDaysCount(formattedStartDate, formattedDate.formattedISOS);
        gaEndDateIsSelected(
          props.data.activeLobbyTab,
          props.data.startedFromPackage,
          props.data.otpData.validatedCostumerData?.isSeparatedSale,
          props.data.epiStyleInitializationData.businessIndividualLobby,
          daysCount
        );
        props.saveSelectedEndDate({selectedEndDate: formattedDate.formattedUI, datePickerEndJSFormat: formattedDate.formattedISOS});
        props.validateAndStartSearching(formattedStartDate, formattedDate.formattedISOS);
      }
    });
  };

  return (
    <Col
      className={`datepicker-custom-container p-0 ${
        isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'isMobile' : ''
      }`}>
      <DatePicker
        wrapperClassName='datepicker-custom-wrapper'
        calendarClassName='datepicker-custom-calendar'
        minDate={new Date()}
        locale={he}
        selected={props.data.dates.datePickerStartJSFormat ? startDate : null}
        onChange={onChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        inline
        monthsShown={1}
      />
    </Col>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
  };
};

const mapDispatchToProps = {
  saveSelectedStartDate,
  saveSelectedEndDate,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatePickerComponent);
